import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';
import Const from 'constants';
import {addRoleSuffix, getSimplexUnitName} from 'helpers/simplex-helper';

export default class LpShowdown extends BaseLP {
    createGroupsOfStacks({incomingValues: {dispatch}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        dispatch(Action.do('createGroupsOfPositionStacks', preparedPlayers.groupedBy.teamAndPosition()));
    }

    preparePlayerByLPPlayerId({incomingValues: {id}}) {
        return this.exec('preparePlayerByLPPlayerId_ShowDown', {id});
    }

    prepareMaxSection({incomingValues = {}}) {
        return this.exec('prepareMaxSection_ShowDown', incomingValues);
    }

    prepareSectionByTeam({incomingValues = {}}) {
        return this.exec('prepareSectionByTeam_ShowDown', incomingValues);
    }

    prepareSectionByUniquePosition({incomingValues = {}}) {
        return this.exec('prepareSectionByUniquePosition_ShowDown', incomingValues);
    }

    prepareSectionByCaptainPosition({incomingValues = {}}) {
        return this.exec('prepareSectionByCaptainPosition_ShowDown', incomingValues);
    }

    prepareSectionBySalary({incomingValues = {}}) {
        return this.exec('prepareSectionBySalary_ShowDown', incomingValues);
    }

    prepareSectionByPlayer({incomingValues = {}}) {
        return this.exec('prepareSectionByPlayer_ShowDown', incomingValues);
    }

    prepareSectionByCreatedLineups({incomingValues = {}}) {
        return this.exec('prepareSectionByCreatedLineups_ShowDown', incomingValues);
    }

    prepareSectionByExposureMax({incomingValues = {}}) {
        return this.exec('prepareSectionByExposureMax_ShowDown', incomingValues, {});
    }

    prepareSectionByExposureMin({incomingValues = {}}) {
        return this.exec('prepareSectionByExposureMin_ShowDown', {
            salaryMode: Const.FLEX_MODE,
        });
    }

    prepareSectionByStacks({incomingValues = {}}) {
        return this.exec('prepareSectionByStacks_ShowDown', incomingValues);
    }

    prepareGeneralSection({incomingValues = {}}) {
        return this.exec('prepareGeneralSection_ShowDown', incomingValues);
    }

    prepareBoundSection({incomingValues = {}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const playersGroupedById = preparedPlayers.groupedBy.playerId();

        let result = {};
        Object.keys(playersGroupedById).map((pId) => {
            let player = playersGroupedById[pId];
            let prefix = getSimplexUnitName(pId);

            const isExcludedByCapMode = player.isExcludedByMode(Const.CAPTAIN_MODE, {
                salaryMode: Const.FLEX_MODE,
            });
            result[addRoleSuffix({prefix, role: Const.CAPTAIN_MODE})] = {
                atLeast: 0,
                atMost: isExcludedByCapMode ? 0 : 1,
            };

            const isExcludedByFlexMode = player.isExcludedByMode(Const.FLEX_MODE);
            result[addRoleSuffix({prefix, role: Const.FLEX_MODE})] = {
                atLeast: 0,
                atMost: isExcludedByFlexMode ? 0 : 1,
            };
        });
        //console.log("bound\n",result);
        return result;
    }

    prepareMaxRandomSection({incomingValues = {}}) {
        return this.exec('prepareMaxRandomSection_ShowDown', incomingValues);
    }

    subjectToPermanent() {
        const constraints = {
            players: this.exec('prepareSectionByPlayer', {}, ''),
            salary: this.exec('prepareSectionBySalary', {}, ''),
            projectedOwnershipCap: this.exec(
                'projectedOwnership',
                {
                    modes: [Const.DEFAULT_MODE, Const.CAPTAIN_MODE],
                },
                '',
            ),
            teams: this.exec('prepareSectionByTeam', {}, ''),
            captainPositions: this.exec('prepareSectionByCaptainPosition', {}, ''),
            // stacks: this.exec('prepareSectionByStacks', {}, ''),
            keyPlayerStacking: this.exec(
                'keyPlayerStacking',
                {
                    modes: [Const.DEFAULT_MODE, Const.CAPTAIN_MODE],
                },
                '',
            ),
            projectionBoostRule: this.exec(
                'projectionBoostRule',
                {
                    modes: [Const.DEFAULT_MODE, Const.CAPTAIN_MODE],
                },
                '',
            ),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            playersWhoseGamesAreLocked: this.exec(
                'playersWhoseGamesAreLocked',
                {
                    checkIfPlayerOnDoublePosition: true,
                },
                '',
            ),
            uniquePositions: this.exec('prepareSectionByUniquePosition', {}, ''),
            createdLineups: this.exec('prepareSectionByCreatedLineups', {}, ''),
            singlegameForcedStacking: this.exec('singlegameForcedStacking', {}, ''),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            playerCombinationStacking: this.exec(
                'playerCombinationStacking',
                {
                    modes: [Const.DEFAULT_MODE, Const.CAPTAIN_MODE],
                },
                '',
            ),
        };

        return {...constraints};
    }
}
